import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import PopularSection from './components/PopularSection';
import ReviewSection from './components/ReviewSection';
import CTASection from './components/CTASection';
import { featuredComics, latestComics } from '@/mocks/comics';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '韩漫画网',
      url: 'http://chinahangnuo.com/',
      description: '韩漫画网提供免费漫画在线阅读和韩国漫画网站大全，覆盖热血、恋爱、奇幻、悬疑等多种韩国漫画类型。',
      sameAs: ['http://chinahangnuo.com/'],
    },
    {
      '@type': 'WebSite',
      name: '韩漫画网',
      url: 'http://chinahangnuo.com/',
      description: '免费韩国漫画在线阅读平台',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'http://chinahangnuo.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '韩漫画网 - 免费韩国漫画在线阅读',
      url: 'http://chinahangnuo.com/',
      description: '韩漫画网提供免费漫画在线阅读和韩国漫画网站大全，内容多样画质佳，是您漫画爱好者的必备工具。',
      isPartOf: { '@type': 'WebSite', name: '韩漫画网', url: 'http://chinahangnuo.com/' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '韩漫画网有哪些类型的漫画？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '韩漫画网涵盖热血、恋爱、奇幻、悬疑、搞笑、日常等多种类型的韩国漫画，满足不同读者的阅读需求。所有漫画均为高清画质，每日持续更新。',
          },
        },
        {
          '@type': 'Question',
          name: '韩漫画网需要付费吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '韩漫画网完全免费，所有韩国漫画均可免费在线阅读，无需付费订阅。我们致力于为漫画爱好者提供优质的免费漫画阅读体验。',
          },
        },
        {
          '@type': 'Question',
          name: '韩国漫画多久更新一次？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '韩漫画网每日更新，热门连载漫画保持稳定的更新频率。您可以通过订阅我们的邮件通知，第一时间获取最新更新信息。',
          },
        },
        {
          '@type': 'Question',
          name: '如何在韩漫画网找到想看的漫画？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '您可以通过首页的分类导航按类型浏览，也可以使用搜索功能查找特定漫画作品。热门推荐和最新更新区域会为您精选优质内容。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="免费漫画在线阅读 - 韩国漫画网站大全 - 韩漫画网"
        description="韩漫画网提供免费漫画在线阅读和韩国漫画网站大全，内容多样画质佳，涵盖热血、恋爱、奇幻、悬疑等多种类型韩国漫画，是您漫画爱好者的必备工具。"
        keywords="免费漫画在线阅读,韩国漫画网站大全,韩漫画网,韩国漫画,免费漫画,韩漫"
        canonicalUrl="http://chinahangnuo.com/"
        ogType="website"
        schema={homeSchema}
      />

      <HeroSection />

      <CategoryNav />

      <PopularSection
        id="popular"
        title="热门推荐"
        subtitle="最受读者欢迎的韩国漫画"
        comicsSlice={featuredComics.slice(0, 6)}
      />

      <PopularSection
        id="latest"
        title="最新更新"
        subtitle="每日更新的最新韩漫章节"
        comicsSlice={latestComics.slice(0, 6)}
      />

      <ReviewSection />

      <CTASection />

      <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
        <div className="max-w-[800px] mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-10">
            常见问题
          </h2>
          <div className="space-y-4">
            <details className="bg-background-50 rounded-lg border border-background-200/60 group">
              <summary className="px-6 py-4 text-sm font-medium text-foreground-800 cursor-pointer list-none flex items-center justify-between">
                韩漫画网有哪些类型的漫画？
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
              </summary>
              <p className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                韩漫画网涵盖<strong>热血、恋爱、奇幻、悬疑、搞笑、日常</strong>等多种类型的韩国漫画，满足不同读者的阅读需求。所有漫画均为高清画质，每日持续更新。
              </p>
            </details>
            <details className="bg-background-50 rounded-lg border border-background-200/60 group">
              <summary className="px-6 py-4 text-sm font-medium text-foreground-800 cursor-pointer list-none flex items-center justify-between">
                韩漫画网需要付费吗？
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
              </summary>
              <p className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                韩漫画网<strong>完全免费</strong>，所有韩国漫画均可免费在线阅读，无需付费订阅。我们致力于为漫画爱好者提供优质的免费漫画阅读体验。
              </p>
            </details>
            <details className="bg-background-50 rounded-lg border border-background-200/60 group">
              <summary className="px-6 py-4 text-sm font-medium text-foreground-800 cursor-pointer list-none flex items-center justify-between">
                韩国漫画多久更新一次？
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
              </summary>
              <p className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                韩漫画网<strong>每日更新</strong>，热门连载漫画保持稳定的更新频率。您可以通过订阅我们的邮件通知，第一时间获取最新更新信息。
              </p>
            </details>
            <details className="bg-background-50 rounded-lg border border-background-200/60 group">
              <summary className="px-6 py-4 text-sm font-medium text-foreground-800 cursor-pointer list-none flex items-center justify-between">
                如何在韩漫画网找到想看的漫画？
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
              </summary>
              <p className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                您可以通过首页的<strong>分类导航</strong>按类型浏览，也可以使用搜索功能查找特定漫画作品。热门推荐和最新更新区域会为您精选优质内容。
              </p>
            </details>
          </div>
        </div>
      </section>
    </>
  );
}